import { TAG_URL_PREFIX } from './constants';

/** Trailing "-{digits}" of a "{slug}-{id}" topic path segment; the id is the routing key, the slug is display-only. */
export const SEO_TOPIC_ID_PATTERN = /-(\d+)$/;

/** Tag id of a "{slug}-{id}" topic path segment, null when the segment has no trailing id. */
export function getSeoTopicTagId(topic: string): string | null {
    return SEO_TOPIC_ID_PATTERN.exec(topic)?.[1] ?? null;
}

/**
 * Builds the "{slug}-{id}" path segment for the SEO topic route, or null when the tag has no
 * usable slug: absent, url-breaking ("%" included — it throws in decodeURIComponent during url
 * generation), or the degenerate "tag-{id}" echo that backends serve before the slug rollout
 * reaches them.
 */
export function getSeoTopicRouteParam(tagId: number, slug: string | null | undefined): string | null {
    const normalized = slug?.trim().toLowerCase();
    if (!normalized || normalized === `${TAG_URL_PREFIX}${tagId}` || /[/?#%\s]/.test(normalized)) {
        return null;
    }
    return `${normalized}-${tagId}`;
}
